import {errorMessage} from 'shared/actions/notifications';
import browserHistory from 'shared/history';
import req from 'shared/req';
import {educatorEmailConfirmed} from './educator';
import {EDUCATOR_CONFIRMATION_CODE_RESEND} from '../action-types/email-confirmation';

export const openEmailConfirmationModal = () => () =>
  browserHistory.push(`${location.pathname}/confirm-email`);

export const closeEmailConfirmationModal = () => () =>
  browserHistory.push(location.pathname.split('/confirm-email')[0]);

const confirmationCodeResend = (success = true) => ({
  type: EDUCATOR_CONFIRMATION_CODE_RESEND,
  success,
});

export const confirmEducatorEmail =
  ({confirmationCode}) =>
  (dispatch) =>
    req({
      url: `/rest/confirmation-code-requests/${confirmationCode}/verify`,
      method: 'PUT',
    }).then(() => {
      dispatch(educatorEmailConfirmed());
      closeEmailConfirmationModal();
    });

export const sendConfirmationCode = ({_id, email}) =>
  req({
    url: '/rest/confirmation-code-requests',
    method: 'POST',
    data: {
      user_id: _id,
      recipient_address: email,
      request_action: 'educator-confirmation-code-fre',
    },
  });

export const resendConfirmationCode =
  ({_id, email}) =>
  (dispatch) =>
    sendConfirmationCode({_id, email})
      .then(() => {
        dispatch(confirmationCodeResend());
      })
      .catch(() => {
        dispatch(
          errorMessage(
            'Oops! There was a problem sending you a verification code. Please contact support@raiseme.zendesk.com.'
          )
        );
      });
